"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfo = void 0;
var date_fns_1 = require("date-fns");
var getPriorityInfo = function (elecInfo, gasInfo) {
    var statusPriority = ['ok', 'warning', 'due', 'error']; // 'error' is the highest priority, 'ok' is the lowest priority
    var elecPriority = statusPriority.indexOf(elecInfo.status);
    var gasPriority = statusPriority.indexOf(gasInfo.status);
    return elecPriority > gasPriority ? elecInfo : gasInfo;
};
var getInfo = function (elecInfo, gasInfo) {
    if (!elecInfo.meterType && !gasInfo.meterType) {
        return __assign(__assign({}, elecInfo), { status: 'error' }); //it does not matter which one we show, both trad and smart have the same error state
    }
    // For single meters, show the state for that meter.
    if (elecInfo.meterType && !gasInfo.meterType) {
        return elecInfo;
    }
    else if (!elecInfo.meterType && gasInfo.meterType) {
        return gasInfo;
    }
    if (elecInfo.meterType === gasInfo.meterType) {
        if (elecInfo.status === gasInfo.status) {
            // for meters of the same type and state show the one with the oldest last meter read (or elec if all the same)
            return (0, date_fns_1.isBefore)(gasInfo.lastReadingDate, elecInfo.lastReadingDate)
                ? gasInfo
                : elecInfo;
        }
    }
    else if (elecInfo.status === gasInfo.status) {
        // for meter of different type but with the same state show the trad state
        return elecInfo.meterType === 'traditional' ? elecInfo : gasInfo;
    }
    // for meter of the same type but different state or different type and state, show the highest priority one
    return getPriorityInfo(elecInfo, gasInfo);
};
exports.getInfo = getInfo;
